import { fixedBody, unFixedBody } from './lib/fixedBody'

// イベントハンドラーの初期化を関数化
const initializeOverlayEvents = () => {
	$('.js-overlay--content').addClass('d-none')

	$(document).on('click', '.js-overlay--button-open', function(e) {
		e.preventDefault()
		e.stopPropagation()
		const key = $(this).data('key')
		if (key) {
			$(`.js-overlay--content[data-key="${key}"]`).removeClass('d-none')
			fixedBody()
		}
	})

	$(document).on('click', '.js-overlay--button-close', function(e) {
		e.preventDefault()
		const key = $(this).data('key')
		if (key) {
			$(`.js-overlay--content[data-key="${key}"]`).addClass('d-none')
			unFixedBody()
		}
	})
}

document.addEventListener('turbolinks:load', () => {
	$(document).off('click', '.js-overlay--button-open')
	$(document).off('click', '.js-overlay--button-close')

	initializeOverlayEvents()
})

document.addEventListener('DOMContentLoaded', () => {
	if (!window.Turbolinks) {
		initializeOverlayEvents()
	}
})
